import { ANALYTICS_EVENTS, trackEvent } from "@/lib/analytics";
// This document is prerendered and its FAQ is never hydrated, so the row a
// #faq- link points at has to be opened here, for any deep link into the
// FAQ.
import { watchFaqTargets } from "@/lib/faq-target";
watchFaqTargets();
const rawSource = new URLSearchParams(window.location.search).get("source");
const source = rawSource && /^[a-zA-Z0-9_-]+$/.test(rawSource) ? rawSource.slice(0, 80) : "marketing";
trackEvent(ANALYTICS_EVENTS.PRO_PAGE_VIEWED, { source });